export default __webpack_public_path__ + "static/media/skate-acc-banner.73d6cd29.jpg";